module.exports = __webpack_public_path__ + "static/media/WhaleLogo-Official3.39f8143a.png";